import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { dateFormat } from '../../dateHelpers';

const DateCellRenderer = ({ value }) =>
  value
    ? <div>{moment.utc(value).local().format(dateFormat)}</div>
    : null;

DateCellRenderer.propTypes = {
  value: PropTypes.string,
};

export default DateCellRenderer;
